import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Flex, Icon } from 'Components/UI'

export const Container = styled(Flex).attrs({
  justifyContent: 'space-evenly',
})`
  border: 1px solid ${themeGet('colors.lightGrey')};
  border-radius: ${({ roundedborder }) =>
    roundedborder ? themeGet('borderRadius.2') : themeGet('borderRadius.1')};
`

const activeCss = props =>
  props.active &&
  css`
    color: ${props.activecolor};
    fill: ${props.activecolor};
    background-color: white;
    font-weight: 500;
  `

export const Option = styled(Flex).attrs({
  py: [2, 2, 2, '10px'],
  px: [14, 20],
  alignItems: 'center',
})`
  user-select: none;
  cursor: ${({ active }) => (active ? 'default' : 'pointer')};
  font-size: 12px;
  font-weight: 500;
  background-color: ${themeGet('colors.concrete')};
  color: ${themeGet('colors.text')};
  fill: ${themeGet('colors.text')};

  &:first-child,
  &:last-child {
    border-radius: ${({ roundedborder }) =>
      roundedborder ? themeGet('borderRadius.2') : themeGet('borderRadius.1')};
  }

  &:first-child {
    border-bottom-right-radius: unset;
    border-top-right-radius: unset;
  }

  &:last-child {
    border-bottom-left-radius: unset;
    border-top-left-radius: unset;
  }

  &:not(:last-child) {
    border-right: 1px solid ${themeGet('colors.lightGrey')};
  }

  ${activeCss};

  &:hover {
    color: ${({ activecolor }) => activecolor};
    fill: ${({ activecolor }) => activecolor};
    background-color: white;
  }
`

export const OptionIcon = styled(Icon).attrs({
  size: 14,
  mr: 2,
})``
